import React from 'react';
import { Box, Typography, Container, Paper } from '@mui/material';

const WelcomePage = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '80vh',
      }}
    >
      <Box sx={{ textAlign: 'center', borderRadius: 2 }}>
        <Typography variant="h4" color="primary" gutterBottom>
          Welcome to SAMS
        </Typography>
        <Typography variant="subtitle2" color="textSecondary">
          You do not have access to any features. Please contact your admin to
          get permissions.
        </Typography>
      </Box>
    </Box>
  );
};

export default WelcomePage;
